import useScreen from '@/hooks/useScreen';
import Div from '@/shared/Div';
import Span from '@/shared/Span';
import Image from '@/shared/Image';
import { memo } from 'react';
import Paragraph from '@/shared/Paragraph';
import Heading from '@/shared/Heading';
import Button from '@/shared/Button';
import { AMC_DEVICE_PAGE_URL } from '@/configs/constants';

const HeroBanner = ({ desktopBanner, mobileBanner, contentImage, title, subTitle }: any) => {
  const { isDesktop } = useScreen();
  return (
    <Div className="relative -mx-6">
      <Image
        width={430}
        loading="eager"
        priority
        height={742}
        alt=""
        className="w-full h-auto"
        cmsImage={isDesktop ? desktopBanner : mobileBanner}
      />
      <Span className="absolute flex-col top-12 left-0 right-0 flex items-center justify-center w-full px-s4 md:mx-auto ">
        <Image
          alt=""
          priority
          loading="eager"
          width={270}
          height={64}
          cmsImage={contentImage}
          className="h-16 md:h-24 w-auto"
        />
        <Heading
          level={1}
          className="mt-2 uppercase text-xl font-extrabold md:text-4xl text-[#F4FBF9] leading-7 md:leading-[3rem]"
        >
          {title}
        </Heading>
        <Paragraph className=" mt-8 md:mt-10 text-h-3 md:text-h-2 text-[#F4FBF9]">
          {subTitle}
        </Paragraph>
        <Div className="flex mt-s6 gap-s5 justify-end w-full md:max-w-md">
          <Button
            theme="secondary"
            className="text-body-lg gap-s5 w-full !px-s6 !py-s4"
            href={AMC_DEVICE_PAGE_URL}
          >
            Buy AMC
          </Button>
          <Button className="text-body-lg gap-s5 w-full px-s6 py-s4" href={AMC_DEVICE_PAGE_URL}>
            Book Service
          </Button>
        </Div>
      </Span>
    </Div>
  );
};

export default memo(HeroBanner);
